<template>
    <div class="pt610">
    <breadcrumb :decriptPage="$t('pt610.labels.memberInfo')"></breadcrumb>
    
    <div class="section page-mypage mb32">
        <h2>{{$t('pt610.labels.memberInfo')}}</h2>
        <div class="section-inner">
            <h3>{{$t('pt610.labels.memberInfo')}}</h3>

            <template v-if="displayFlg == 0">
                <message :listMess="listMessValid" :mapMsg="mapMessValid" :idScreen="PT610_PART"/>
                <div class="pt-3 pb-3" v-if="report != ''"> <span class="text-danger">{{report}} </span></div>
                <p class="mb16">{{$t('pt610.labels.messg4')}}</p>
                <br>
                <div style="display:none;">
                    <span id="nyusyaDayWarekiKbn_lbl">{{$t('pt610.labels.nyusyaDayWarekiKbn')}}</span>
                    <span id="nyusyaDayWarekiYear_lbl">{{$t('pt610.labels.nyusyaDayWarekiYear')}}</span>
                    <span id="nyusyaDayMM_lbl">{{$t('pt610.labels.nyusyaDayMM')}}</span>
                    <span id="nyusyaDayDD_lbl">{{$t('pt610.labels.nyusyaDayDD')}}</span>
                </div>
                <table class="personal mb32">
                    <!-- メールアドレス-->
                    <tr>
                        <th id="mail_lbl">
                            {{$t('common.labels.mailAddress')}}
                        </th>
                        <td>
                            {{pt610Request.mail}}
                        </td>
                    </tr>
                    <!-- 社員番号-->
                    <tr>
                        <th class="required" id="kokyakuCd_lbl">{{$t('pt610.labels.kokyakuCd')}}</th>
                        <td>
                            <input-check type="text" name="kokyakuCd" size="20" maxlength="16" id="kokyakuCd" class="form-control-sm" v-model="pt610Request.kokyakuCd" />
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <th class="required" id="kana1_lbl">{{$t('pt610.labels.name')}}</th>
                        <td>
                            <div class="form-column">
                                <input-check type="text" name="kana1" size="20" class="form-control-sm" id="kana1" maxlength="20" v-model="pt610Request.kana1" />
                            </div><!--/ .form-column -->
                            <!--項目説明マスタ[7]-->
                            <div v-html="pt610Init.descriptionInfo['7']"></div>
                        </td>
                    </tr>
                    <tr>
                        <th class="required">
                            <!-- 入社年月日 -->
                            <span id="nyusyaDay_lbl">{{$t('pt610.labels.nyusyaDay')}}</span>
                        </th>
                        <td class="nyusyaSelect">
                            <select v-model="pt610Request.nyusyaDayWarekiKbn" class="form-control-sm" id="nyusyaDayWarekiKbn" name="nyusyaDayWarekiKbn"> 
                                <option v-for="wareki in pt610Init.warekiList" :key="wareki.KEY" :value="wareki.KEY">{{wareki.VALUE}}</option>
                            </select>
                            <select v-model="pt610Request.nyusyaDayWarekiYear" id="nyusyaDayWarekiYear" name="nyusyaDayWarekiYear" class="form-control-sm">
                                <option></option>
                                <template v-for="mm in 64" >
                                    <option v-if="mm < 10" :key="mm" :value="'0'+mm">{{'0'+mm}}</option>
                                    <option v-else :key="mm" :value="mm">{{mm}}</option>
                                </template>
                            </select>&nbsp;{{$t('common.labels.year')}}&nbsp;
                            <select v-model="pt610Request.nyusyaDayMM" id="nyusyaDayMM" name="nyusyaDayMM" class="form-control-sm">
                                <option></option>
                                <template v-for="mm in 12" >
                                    <option v-if="mm < 10" :key="mm" :value="'0'+mm">{{'0'+mm}}</option>
                                    <option v-else :key="mm" :value="mm">{{mm}}</option>
                                </template>
                            </select>&nbsp;{{$t('common.labels.month')}}&nbsp;
                            <select v-model="pt610Request.nyusyaDayDD" id="nyusyaDayDD" name="nyusyaDayDD" class="form-control-sm">
                                <option></option>
                                <template v-for="dd in 31" >
                                    <option v-if="dd < 10" :key="dd" :value="'0'+dd">{{'0'+dd}}</option>
                                    <option v-else :key="dd" :value="dd">{{dd}}</option>
                                </template>
                            </select>&nbsp;{{$t('common.labels.day')}}&nbsp;
                            <!--項目説明マスタ[1]-->
                            <div v-html="pt610Init.descriptionInfo['1']"></div>
                        </td>
                    </tr>
                    <!--郵便番号 -->
                    <tr>
                        <th class="required" id="zip_lbl">{{$t('common.labels.postalCode')}}</th>
                        <td>
                            <div class="form-column">
                                <input-check type="text" class="zip form-control-sm" name="zip" size="10" id="zip" maxlength="8" v-model="pt610Request.zip" @on-input-change="addrAutoInput('kokyaku')"/>
                                <span class="btn_addsearch"><a @click="addrAutoInput('kokyaku')">{{$t('common.labels.addressSearch')}}</a></span>
                            </div>
                            <!--項目説明マスタ[2]-->
                            <div v-html="pt610Init.descriptionInfo['2']"></div>
                        </td>
                    </tr>
                    <!--都道府県 -->
                    <template v-if="pt610Init.kenPulldownDispFlg == 1">
                        <tr>
                            <th class="required" id="kenCd_lbl">{{$t('common.labels.prefectures')}}</th>
                            <td>
                                <select v-model="pt610Request.kenCd" class="form-control-sm kenCd" id="kenCd" name="kenCd"> 
                                    <option v-for="kenCd in pt610Init.kenCdList" :key="kenCd.KEY" :value="kenCd.KEY">{{kenCd.VALUE}}</option>
                                </select>
                            </td>
                        </tr>
                    </template>
                    <!--住所1 -->
                    <tr>
                        <th class="required" id="addr1_lbl">{{$t('pt610.labels.address')}}</th>
                        <td>
                            <input-check type="text" class="form-control-sm w-100" name="addr1" size="50" id="addr1" maxlength="50" v-model="pt610Request.addr1" />
                            &nbsp;<br>
                            <!--項目説明マスタ[3]-->
                            <div v-html="pt610Init.descriptionInfo['3']"></div>
                        </td>
                    </tr>
                    <!--電話番号 -->
                    <tr>
                        <th class="required" id="tel1_lbl">{{$t('pt610.labels.phoneNumber')}}</th>
                        <td>
                            <input-check type="text" id="tel1" name="tel1" class="code form-change form-control-sm" size="18" maxlength="15" v-model="pt610Request.tel1" />
                            &nbsp;
                            <!--項目説明マスタ[4]-->
                            <div v-html="pt610Init.descriptionInfo['4']"></div>
                        </td>
                    </tr>
                    <!-- パスワード-->
                    <tr>
                        <th class="required">
                            <span id="password_lbl">{{$t('pt610.labels.newPass')}}</span>
                        </th>
                        <td>
                            <!--項目説明マスタ[5]-->
                            <div v-html="pt610Init.descriptionInfo['5']"></div>
                            <input-check type="password" name="password" size="20" class="form-control-sm" maxlength="16" id="password" v-model="pt610Request.password" />
                            &nbsp;
                            <!--項目説明マスタ[6]-->
                            <div v-html="pt610Init.descriptionInfo['6']"></div>
                        </td>
                    </tr>
                    <tr>
                        <th class="required">
                            <span id="passwordSub_lbl">{{$t('pt610.labels.passConfirm')}}</span>
                        </th>
                        <td>
                            <span class="repeat mb08">{{$t('pt610.labels.pleaseEnter2')}}</span>
                            <input-check type="password" name="passwordSub" size="20" maxlength="16" class="form-control-sm" id="passwordSub" v-model="pt610Request.passwordSub" />
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <div id="btn_roll2">
                    <a class="submit-button" @click="confirmDoInsert()">{{$t('common.buttons.signup')}}</a>
                </div>
			</template>
			<!-- 登録完了画面 -->
			<template v-else>
                <p class="completion mb64">
                    {{$t('pt610.labels.dicription')}}
                    <br>
                    {{$t('pt610.labels.dicription2')}}
                </p>
                <router-link :to="{ name: SiteConstants.PG010MAIN, query: {pageNo: 18}}">
                    {{$t('pt610.labels.toLoginPage')}}
                </router-link>
			</template>
        </div><!--/ .section-inner -->
        <!-- modal confirm area -->
        <alert-confirm 
            v-if="isModalShow"
            :msgConfirm="msgConfirm"
            :okAction="doAction"
            :isButtonCancel="isButtonCancel">
        </alert-confirm>
    </div>
    <CC212 v-if="cc212Dislay" @modal-close="cc212Dislay = false" :propTdkZip1 ="dataCc212.propTdkZip1" :propTdkZip2 ="dataCc212.propTdkZip2" @set-addr-value="selectData"></CC212>
</div>
</template>


<script>
/* eslint-disable */
/*
* Import libs and componnents
*/
import $ from 'jquery';
import axios from "assets/js/request";
import DataTable from 'components/Datatable';
import common from 'assets/js/common';
import BackButton from 'components/BackButton';
import EventBus from 'assets/js/eventBus';
import Message from 'components/MessageEcSite';
import Loading from 'vue-loading-overlay';
import InputCheck from 'components/InputCheck.vue';
import DownloadFile from 'components/DownloadFile';
import AlertConfirm from 'components/AlertConfirm';
import SiteConstants from 'assets/const/SiteConstants.json';
import InputNumber from 'components/InputNumber';
import CC212 from '../search/CC212InputPostal.vue';
import Breadcrumb from "../commonParts/Breadcrumb.vue";

export default {
    /*
    * Name of component
    */
    name: "PT610MemberInfoParts",
    /*
    * Declare props
    */
    props: {
        ptInitData: {
            type: Object,
            default: null,
        }
    },

    /*
    * Declare components
    */
    components: {
        DataTable,
        BackButton,
        Message: Message,
        Loading,
        InputCheck,
        DownloadFile,
        AlertConfirm,
        InputNumber,
        CC212,
        Breadcrumb
    },
    /*
    * Declare variable and set default value
    */
    data: function() {
        return {
            PT610_PART: 'pt610',
            isLoading: false,
            isDisplay: false,
            pt610Init: {},
            pt610Request: {
                agreeFlag:0,
                zip:null,
                zip1:null,
                zip2:null,
                addr1:null,
                addr2:null,
                addr3:null,
                uuid:null
            },
            isButtonCancel: true,
            actionFlg:0,
            isModalShow:false,
            listIdErr:[],
            SiteConstants: SiteConstants,
            isModalShow:false,
            msgConfirm:'',
            listMessValid:[],
            mapMessValid:[],
            report:'',
            isButtonOK:false,
            cc212Dislay:false,
            dataCc212: {},
            cc212ReqModel:{},
            site: "",
            displayFlg:0
        }
    },
    /*
    * Initialize
    */
    mounted: function() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];

        if (_this.ptInitData){
            _this.pt610Init = _this.ptInitData;
            _this.pt610Request = Object.assign({}, _this.pt610Request, _this.ptInitData.reqModel);

            if(_this.ptInitData.errList != null && _this.ptInitData.errList.length > 0){
                _this.displayWarning(_this.ptInitData.errList);
            }

            //ワークに存在しない、有効期限切れの場合初回アクセスパーツに戻る
            if(_this.pt610Init.errFlg == "1"){
                _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 100},params:{returnErrFlg:'1'}});
            }
        }else{
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT610 + _this.$UrlConstants.DO_INIT,_this.pt610Request).then(function(response) {
                _this.pt610Init = response.data;
                _this.pt610Request = Object.assign({}, _this.pt610Request, response.data.reqModel);

                if(response.data.errList != null && response.data.errList.length > 0){
                    _this.displayWarning(response.data.errList);
                }

                //ワークに存在しない、有効期限切れの場合初回アクセスパーツに戻る
                if(_this.pt610Init.errFlg == "1"){
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 100},params:{returnErrFlg:'1'}});
                }

            }).catch(function(error) {
                common.errorAPI(error);
            });
        }

        //close pupup
        EventBus.$on('closed', function() {
            _this.isModalShow = false;
        });
    },
    /*
    * Methods
    */
    methods: {
        confirmDoInsert: function(){
            this.msgConfirm = this.$i18n.t('pt610.labels.messg2')
            this.isModalShow = true;
            this.isButtonCancel = true;
            this.actionFlg = 1;
        },
        /*
        *  add new user
        */
        doInsert: function(){
            var _this = this;
            _this.$emit("event-loading", true);
            _this.report = '';
            //clear msg valid
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.PT610_PART);
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT610 + _this.$UrlConstants.DO_INSERT, _this.pt610Request).then(function(response) {
                var fromCart = _this.pt610Request.fromCart != null? _this.pt610Request.fromCart:'';
                if(response.data.errFlg == '0'){
                    //顧客情報正常登録時には画面に登録完了の文言を表示
                    _this.displayFlg = 1;
                }else{
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 100},params:{returnErrFlg:response.data.errFlg}});
                }
                
                if(response.data.errList != null && response.data.errList.length > 0){
                    _this.displayWaring(response.data.errList);
                }

                _this.$emit("event-loading", !true);
            }).catch(function(error) {
                _this.$emit("event-loading", !true);
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error, _this.PT610_PART);
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                            common.scrollTop();
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },

         /*
        *  execute update or delete or insert
        */
        doAction: function(){
            var _this = this;
            switch (this.actionFlg) {
                case 1:
                    this.doInsert();
                    break;
                case 2:
                    this.doUpdate();
                    break;
                default:
                    break;
            }
            // Hide alert confirm
            this.isModalShow = false;
            this.actionFlg = 0;
            this.isButtonCancel = true;
        },
         /*
        * Function stringNvl
        */
        stringNvl: function(strVal, defVal){
            if(strVal==undefined){
                return defVal;
            }else{
                return strVal;
            }
        },
        /* 
        * Function excuteValidation 
        * analyst data message and display
        */
        displayWarning(errorList){
            var idList  = [];
            var mapMsg = [];
            var msgList = [];
            var listIdErr = [];
            // check error list
            if(errorList != null && errorList.length > 0){
                //var errorList = error.response.data.errorList;
                for(var index =0;  index < errorList.length; index ++){
                    // row of table
                    var rowTableIndex = errorList[index].rowTableIndex == undefined ? -1 : errorList[index].rowTableIndex;
                    // zoneIndex
                    var zoneIndex = errorList[index].zoneIndex == undefined ? -1 : errorList[index].zoneIndex;

                    // set border-color for input
                    var listGroupId = errorList[index].groupId;
                    if(listGroupId != null && listGroupId.length > 0){
                        for (var keyInx = 0; keyInx < listGroupId.length; keyInx++){
                            var idInput = listGroupId[keyInx];
                            var inputObj = $('#' + idInput);
                            if(inputObj != null && inputObj != undefined){
                                inputObj.css('border-color', "red");
                            }

                            listIdErr.push(idInput);
                        }
                    }

                    // replace messenge
                    var messageList = errorList[index].messageList;
                    if(messageList != null && messageList.length > 0){
                        for (var mesInx = 0; mesInx < messageList.length; mesInx++){
                            var msgTemp = messageList[mesInx].message;
                            var argList =messageList[mesInx].argList;
                            if(argList != null && argList.length > 0){
                                
                                for(var arg=0; arg<argList.length; arg++){
                                    // get lable display of item input 
                                    var idInput = $('#'+ argList[arg] + '_lbl');
                                    var label ='';

                                    if(idInput != null && idInput != undefined){
                                        label =  idInput.text();
                                    }
                                    // replace text for key to display
                                    if(rowTableIndex > -1){
                                        if(label.length > 0){
                                            msgTemp = msgTemp.replace('{' + argList[arg] + '}', label).replace('{rowIndex}', rowTableIndex);   
                                        }else{
                                            msgTemp = msgTemp.replace('{' + argList[arg] + '}', label);   
                                        }
                                    }else{
                                        if(label.length > 0){
                                            msgTemp = msgTemp.replace('{' + argList[arg] + '}', label);   
                                        }
                                    }
                                }
                            }
                            // if message not include key(message common)
                            if(listGroupId != null && listGroupId.length > 0){
                                var obj ={};
                                obj.key = listGroupId[0];
                                obj.mess= msgTemp;
                                mapMsg.push(obj);
                            }else{
                                msgList.push(msgTemp);
                            }
                            
                        }
                    }
                }

                // emit message to componet message
                var msg ={};
                msg.listMess = msgList;
                msg.mapMsg = mapMsg;
                EventBus.$emit('message', msg);
                return listIdErr;
            }
        },
        formatPrice: function(value){
            return common.formatPrice(value);
        },

        addrAutoInput: function(tdkIndex){
            var _this = this;
            _this.tdkIndex = tdkIndex;
            var zip = _this.pt610Request.zip;
            if(_this.tdkIndex != 'kokyaku'){
                zip = _this.pt610Request.tdkList[tdkIndex].tdkZip;
            }
			if(zip == '' || zip == null || zip == undefined) {
				if (_this.isModalShow != true){
					_this.isModalShow = true;
				}
				// 郵便番号は必須です。
				_this.msgConfirm =_this.$i18n.t('sh030.labels.zipCodeIsMandatory');
				_this.isButtonCancel=true;
				_this.isButtonOK=false;
				return;
			}
			var zipArr = zip.split("-");
			var zip1 = "";
			var zip2 = "";
			if (zipArr.length == 2) {
				zip1 = zipArr[0];
				zip2 = zipArr[1];
			}else{
				zip1 = zip.substr(0,3);
				zip2 = zip.substr(3);
			}
			_this.cc212ReqModel.tdkZip1 = zip1;
			_this.cc212ReqModel.tdkZip2 = zip2;
			_this.$emit("event-loading", true);
			axios.post(_this.$UrlConstants.POPUP + _this.$UrlConstants.CC212 + _this.$UrlConstants.GET_ADDR_INFO, _this.cc212ReqModel).then(function(response) {
				if (response.data.allAddr == 'juufuku'){
					_this.dataCc212.propTdkZip1 = zip1;
					_this.dataCc212.propTdkZip2 = zip2;
					_this.cc212Dislay = true;
				}
				else {
					_this.setAddr(response.data.allAddr ,response.data.kenCd,response.data.kenNm, zip1 ,zip2,tdkIndex);
				}
				_this.$emit("event-loading", !true);
			}).catch(function(error) {
				_this.$emit("event-loading", !true);
				common.errorAPI(error);
			});
		},
		// 住所検索Ajaxの戻り
		// パラメータの_addrに「住所,町名番地,建物名・部屋番号」の形で戻ってくる(30文字ずつ)
		setAddr: function (addr, kenCd, kenNm , zip1 , zip2, tdkIndex){
            var _this = this;
            var sp = new Array("","","");
			if (addr) {
                sp = addr.split(",");
                var displayAddr = sp[0]==null?'':sp[0] ;
                displayAddr += sp[1]==null?'':sp[1];
                displayAddr += sp[2]==null?'':sp[2];
                //都道府県のプルダウンを使用しない場合
                if(_this.pt610Init.kenPulldownDispFlg == 0){
                    _this.pt610Request.addr1 = kenNm + displayAddr;
                }else{
                    _this.pt610Request.addr1 = displayAddr;
                }
                _this.pt610Request.kenCd = kenCd;
                _this.pt610Request.zip = zip1+ "-" +zip2;
				_this.$forceUpdate();
			}else{
				if (_this.isModalShow != true){
					_this.isModalShow = true;
				}
				// 郵便番号が存在しません
				_this.msgConfirm =_this.$i18n.t('sh030.labels.zipCodeDoesNotExist');
				_this.pt610Request.zip= '';
				_this.isButtonCancel=true;
				_this.isButtonOK=false;
			}
		},
		selectData(value){
            var _this = this;
            _this.pt610Request.addr1 = value.addr.ALL_ADDR;
            _this.pt610Request.kenCd = value.addr.KEN_CD;
			
			var zip = value.addr.PSTNO;
			var zipArr = zip.split("-");
			var zip1 = "";
			var zip2 = "";
			if (zipArr.length == 2) {
				zip1 = zipArr[0];
				zip2 = zipArr[1];
			}else{
				zip1 = zip.substr(0,3);
				zip2 = zip.substr(3);
			}
            
            _this.pt610Request.zip = zip1+ "-" +zip2;
			_this.$forceUpdate();
		}
    },
    created(){
        var _this = this;
        // Get data from params and query
        var paramData = _this.$route.params;
        var queryData = _this.$route.query;
        
        if(Object.keys(paramData).length > 0){
            _this.pt610Request = Object.assign({}, _this.pt610Request, paramData);
        }

        if(Object.keys(queryData).length > 0){
            _this.pt610Request = Object.assign({}, _this.pt610Request, queryData);
        }

    },

}
</script>